import { StyleGroupDefinition, StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [];

export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [
	{
		cp: 'font',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_default-': '<primaryFont>',
			'_underLine-': '<primaryFont>',
			'_underAboveLine-': '<primaryFont>',
			'_sideLines-': '<primaryFont>',
		},
		gn: 'Font',
		dn: 'Font',
		n: 'iconFont<designType><colorScheme>',
	},
	{
		cp: 'padding',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_sideLines-': '0px 5px',
		},
		gn: 'Padding',
		dn: 'Padding',
		n: 'iconPadding<designType><colorScheme>',
	},
	{
		cp: 'margin',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		gn: 'Margin',
		dn: 'Margin',
		n: 'iconMargin<designType><colorScheme>',
	},
	{
		cp: 'text-decoration',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_default-': 'none',
			'_underLine-': 'none',
			'_underAboveLine-': 'none',
			'_sideLines-': 'none',
		},
		gn: 'Text Decoration',
		dn: 'TextDecoration',
		n: 'iconTextDecoration<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_default-': 'none',
			'_underLine-': 'none',
			'_underAboveLine-': 'none',
			'_sideLines-': 'none, 1px solid transparent, none, 1px solid transparent',
		},
		gn: 'Border',
		dn: 'Border',
		n: 'iconBorder<designType><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_default-_primary': '<fontColorThree>',
			'_default-_secondary': '<fontColorFour>',
			'_default-_tertiary': '<fontColorFive>',
			'_default-_quaternary': '<fontColorNine>',
			'_default-_quinary': '<fontColorSeven>',
			'_underLine-_primary': '<fontColorThree>',
			'_underLine-_secondary': '<fontColorFour>',
			'_underLine-_tertiary': '<fontColorFive>',
			'_underLine-_quaternary': '<fontColorNine>',
			'_underLine-_quinary': '<fontColorSeven>',
			'_underAboveLine-_primary': '<fontColorThree>',
			'_underAboveLine-_secondary': '<fontColorFour>',
			'_underAboveLine-_tertiary': '<fontColorFive>',
			'_underAboveLine-_quaternary': '<fontColorNine>',
			'_underAboveLine-_quinary': '<fontColorSeven>',
			'_sideLines-_primary': '<fontColorThree>',
			'_sideLines-_secondary': '<fontColorFour>',
			'_sideLines-_tertiary': '<fontColorFive>',
			'_sideLines-_quaternary': '<fontColorNine>',
			'_sideLines-_quinary': '<fontColorSeven>',
		},
		gn: 'Color',
		dn: 'Color SideLinescolorScheme',
		n: 'iconColorSideLinescolorScheme<designType><colorScheme>',
	},
	{
		cp: 'text-decoration-color',
		sel: '.comp.compLink<designType><colorScheme>',
		np: true,
		spv: {
			'_default-_primary': '<fontColorThree>',
			'_default-_secondary': '<fontColorFour>',
			'_default-_tertiary': '<fontColorFive>',
			'_default-_quaternary': '<fontColorNine>',
			'_default-_quinary': '<fontColorSeven>',
			'_underLine-_primary': '<fontColorThree>',
			'_underLine-_secondary': '<fontColorFour>',
			'_underLine-_tertiary': '<fontColorFive>',
			'_underLine-_quaternary': '<fontColorNine>',
			'_underLine-_quinary': '<fontColorSeven>',
			'_underAboveLine-_primary': '<fontColorThree>',
			'_underAboveLine-_secondary': '<fontColorFour>',
			'_underAboveLine-_tertiary': '<fontColorFive>',
			'_underAboveLine-_quaternary': '<fontColorNine>',
			'_underAboveLine-_quinary': '<fontColorSeven>',
			'_sideLines-_primary': '<fontColorThree>',
			'_sideLines-_secondary': '<fontColorFour>',
			'_sideLines-_tertiary': '<fontColorFive>',
			'_sideLines-_quaternary': '<fontColorNine>',
			'_sideLines-_quinary': '<fontColorSeven>',
		},
		gn: 'Text Decoration Color',
		dn: 'TextDecorationColor SideLinescolorScheme',
		n: 'iconTextDecorationColorSideLinescolorScheme<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compLink._sideLines<colorScheme>:hover, .comp.compLink._sideLines<colorScheme>._showLines',
		np: true,
		spv: {
			'_default-_primary': '<fontColorThree>',
			'_default-_secondary': '<fontColorFour>',
			'_default-_tertiary': '<fontColorFive>',
			'_default-_quaternary': '<fontColorNine>',
			'_default-_quinary': '<fontColorSeven>',
			'_underLine-_primary': '<fontColorThree>',
			'_underLine-_secondary': '<fontColorFour>',
			'_underLine-_tertiary': '<fontColorFive>',
			'_underLine-_quaternary': '<fontColorNine>',
			'_underLine-_quinary': '<fontColorSeven>',
			'_underAboveLine-_primary': '<fontColorThree>',
			'_underAboveLine-_secondary': '<fontColorFour>',
			'_underAboveLine-_tertiary': '<fontColorFive>',
			'_underAboveLine-_quaternary': '<fontColorNine>',
			'_underAboveLine-_quinary': '<fontColorSeven>',
			'_sideLines-_primary': '<fontColorThree>',
			'_sideLines-_secondary': '<fontColorFour>',
			'_sideLines-_tertiary': '<fontColorFive>',
			'_sideLines-_quaternary': '<fontColorNine>',
			'_sideLines-_quinary': '<fontColorSeven>',
		},
		gn: 'Border Color',
		dn: 'BorderColor ShowLines',
		n: 'iconBorderColorShowLines<designType><colorScheme>',
	},
	{
		cp: 'text-decoration',
		sel: '.comp.compLink<designType><colorScheme>:hover, .comp.compLink<designType><colorScheme>._showLines',
		np: true,
		spv: {
			'_default-': 'none',
			'_underLine-': 'underline',
			'_underAboveLine-': 'underline overline',
			'_sideLines-': 'none',
		},
		gn: 'Text Decoration',
		dn: 'TextDecoration ShowLines',
		n: 'iconTextDecorationShowLines<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compLink<designType><colorScheme>:hover, .comp.compLink<designType><colorScheme>._showLines',
		np: true,
		spv: {
			'_default-': 'none',
			'_underLine-': 'none',
			'_underAboveLine-': 'none',
			'_sideLines-': 'none, 1px solid, none, 1px solid',
		},
		gn: 'Border',
		dn: 'Border ShowLines',
		n: 'iconBorderShowLines<designType><colorScheme>',
	},
];
